import { ErroredModel } from './ErroredModel';

export enum AttachmentOwnerType {
  ACCOUNT = 'Account',
  EVENT = 'Event',
  EMPLOYEE = 'Employee',
  CONTACT = 'Contact',
  TASK = 'Task',
  NOTE = 'Note',
  EMAIL_TEMPLATE = 'EmailTemplate',
  FORM_TEMPLATE = 'FormTemplate',
  FORM_SUBMISSION = 'FormSubmission',
}

export type AttachmentOwner = {
  type: AttachmentOwnerType;
  uuid: string;
};

export type Attachment = ErroredModel & {
  key: string;
  name: string;
  date: string;
  url: string;
  thumb_url?: string;
  size?: number;
  attached_by?: string;
  content_type?: string;
};
